module.exports = __webpack_public_path__ + "static/media/pancake.26084852.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pancake.png
// module id = 2097
// module chunks = 0